export const transformChannel = (raw) => {
  return {
    id: raw?.uuid,
    code: raw?.profile?.code || '',
    name: raw?.profile?.name || '',
    address: raw?.profile?.address || '',
    fee: raw?.profile?.fee || '',
  };
};

export const transformChannelBranch = (raw) => ({
  id: raw?.id || '',
  name: raw?.name || '',
});
